<template>
  <div class="runtime-table-panel">
    <div class="table-wrap">
      <div class="table-head">
        <span v-for="head in heads" :key="head">{{ head }}</span>
      </div>
      <div v-for="row in rows" :key="row.id" class="table-row">
        <span>{{ row.id }}</span>
        <span>{{ row.unit }}</span>
        <span>{{ row.area }}</span>
        <span>{{ row.crop }}</span>
        <span>{{ row.zone }}</span>
        <span>{{ row.value }}</span>
        <span>{{ row.time }}</span>
      </div>
    </div>
    <div class="suggestion-box">
      崇礼乡局部墒情偏低，建议优先补水；东洪区域流量稳定，保持常规监测
    </div>
  </div>
</template>

<script setup>
const heads = ["序号", "用水单元", "灌溉面积", "种植作物", "监测区域", "实时流量", "更新时间"];

const rows = [
  { id: "1.", unit: "泵站A01", area: "320亩", crop: "小麦", zone: "崇礼乡", value: "126m³/h", time: "2分钟前" },
  { id: "2.", unit: "阀门B03", area: "180亩", crop: "玉米", zone: "黄埠镇", value: "38m³/h", time: "1分钟前" },
  { id: "3.", unit: "阀门A07", area: "120亩", crop: "花生", zone: "邵店镇", value: "15m³/h", time: "5分钟前" },
  { id: "4.", unit: "阀门C12", area: "260亩", crop: "小麦", zone: "东洪镇", value: "52m³/h", time: "3分钟前" },
  { id: "5.", unit: "泵站D02", area: "240亩", crop: "玉米", zone: "蔡都街道", value: "84m³/h", time: "4分钟前" },
];
</script>

<style lang="less" scoped>
.runtime-table-panel {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: grid;
  grid-template-rows: 1fr 88px;
  row-gap: 18px;
}

.table-wrap {
  min-height: 0;
  padding: 14px 22px 18px;
  box-sizing: border-box;
  // background: linear-gradient(180deg, rgba(0, 67, 63, 0.82), rgba(0, 45, 46, 0.96));
  border: 1px solid rgba(79, 255, 241, 0.36);
  box-shadow: inset 0 0 40px rgba(67, 255, 239, 0.12);
}

.table-head,
.table-row {
  display: grid;
  grid-template-columns: 0.72fr 1.22fr repeat(5, 1fr);
  align-items: center;
  border-bottom: 1px solid rgba(96, 255, 244, 0.22);
  color: #fff;
  text-align: center;
}

.table-head {
  height: 40px;
  color: rgba(231, 255, 252, 0.82);
  font-size: 22px;
}

.table-row {
  height: calc((100% - 40px) / 5);
  min-height: 48px;
  font-size: 30px;
  font-weight: bold;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.18);

  span:nth-child(1),
  span:nth-child(2) {
    text-align: left;
  }
}

.suggestion-box {
  position: relative;
  height: 88px;
  line-height: 88px;
  color: #ffffff;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  background: linear-gradient(180deg, rgba(2, 65, 61, 0.72), rgba(1, 46, 47, 0.88));
  border: 1px solid rgba(98, 255, 244, 0.48);
  box-shadow: inset 0 0 24px rgba(79, 255, 241, 0.14);

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 110px;
    height: 3px;
    left: 50%;
    margin-left: -55px;
    background: #6ffff5;
    box-shadow: 0 0 14px rgba(111, 255, 245, 0.9);
  }

  &::before {
    top: -2px;
  }

  &::after {
    bottom: -2px;
  }
}
</style>
